var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPalletized = function SvgPalletized(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 62,
    viewBox: "0 0 49 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "a",
    width: 12.024,
    height: 12.621,
    x: 0.807,
    y: 11.381,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    width: 12.024,
    height: 12.621,
    x: 11.214,
    y: 11.381,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "c",
    width: 12.024,
    height: 12.621,
    x: 0.807,
    y: 42.968,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 12.024,
    height: 12.621,
    x: 11.214,
    y: 42.968,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "e",
    width: 12.024,
    height: 12.621,
    x: 26.078,
    y: 11.381,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "f",
    width: 12.024,
    height: 12.621,
    x: 36.484,
    y: 11.381,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "g",
    width: 12.024,
    height: 12.621,
    x: 26.078,
    y: 42.968,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "h",
    width: 12.024,
    height: 12.621,
    x: 36.484,
    y: 42.968,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "i",
    width: 12.024,
    height: 12.621,
    x: 0.807,
    y: 0.624,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "j",
    width: 12.024,
    height: 12.621,
    x: 11.214,
    y: 0.624,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "k",
    width: 12.024,
    height: 12.621,
    x: 0.807,
    y: 32.211,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "l",
    width: 12.024,
    height: 12.621,
    x: 11.214,
    y: 32.211,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "m",
    width: 12.024,
    height: 12.621,
    x: 26.078,
    y: 0.624,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "n",
    width: 12.024,
    height: 12.621,
    x: 36.484,
    y: 0.624,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "o",
    width: 12.024,
    height: 12.621,
    x: 26.078,
    y: 32.211,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "p",
    width: 12.024,
    height: 12.621,
    x: 36.484,
    y: 32.211,
    rx: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -.35)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(.582 25.804)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(.582 57.39)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(25.853 25.804)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#CBAB87",
    transform: "translate(25.853 57.39)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.13,
    height: 1.558,
    y: 2.961,
    rx: 0.779
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.819.779h1.492V4.14h-1.492zM1.492.779h1.492V4.14H1.492zM20.145.779h1.492V4.14h-1.492z"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 12.131,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 12.131,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 43.718,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 43.718,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 12.131,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 12.131,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 18.688,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 43.718,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 43.718,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 50.274,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 1.374,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 1.374,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 1.557,
    y: 32.961,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 6.467,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 11.964,
    y: 32.961,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 16.873,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 1.374,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 1.374,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 7.931,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 26.828,
    y: 32.961,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 31.737,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#F4F7FA",
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.524,
    height: 11.121,
    x: 37.234,
    y: 32.961,
    stroke: "#3F536E",
    strokeWidth: 1.5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    width: 3.317,
    height: 2.176,
    x: 42.143,
    y: 39.517,
    fill: "#0093EE",
    rx: 0.3
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPalletized, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/palletized.9c92551d.svg";
export { ForwardRef as ReactComponent };